module.exports = __webpack_public_path__ + "a34a471e24a805ddc9b06b773900fa0a.png";